import { useRef, useEffect } from "react";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MKTypography from "components/MKTypography";
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import SimpleFooter from "examples/Footers/SimpleFooter";
import routes from "routes";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import { useNavigate } from 'react-router-dom';

const loadScript = (src) =>
  new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) return resolve();
    const script = document.createElement('script');
    script.src = src;
    script.onload = () => resolve();
    script.onerror = (err) => reject(err);
    document.body.appendChild(script);
  });


function SignInBasic() {

  const navigate = useNavigate();
  const handleSubmitClick = () => {
    navigate(`/app/trainingcompanysignin`);
    // window.location.href = "pages/authentication/trainingcompanysign-in";
  }

  console.log("userId", localStorage.getItem("userId"));
  console.log("user", localStorage.getItem("user"));
  console.log("email", localStorage.getItem("email"));
  console.log("token", localStorage.getItem("token"));
  console.log("mobile", localStorage.getItem("mobile"));
  console.log("verified", localStorage.getItem("verified"));
  console.log("number", localStorage.getItem("number"));
  console.log("verified_tc", localStorage.getItem("verified_tc"));

  const googleButton = useRef(null);

  useEffect(() => {
    const src = 'https://accounts.google.com/gsi/client';
    const clientId = "1086866642031-on7hrdcvallmkia5d367uq6ni0impi1i.apps.googleusercontent.com"

    loadScript(src)
      .then(() => {
        /*global google*/
        google.accounts.id.initialize({
          client_id: clientId,
          callback: handleCredentialResponse,
        });
        google.accounts.id.renderButton(googleButton.current, {
          theme: 'outline',
          size: 'large',
        });
      })
      .catch(console.error);

    return () => {
      const scriptTag = document.querySelector(`script[src="${src}"]`);
      if (scriptTag) document.body.removeChild(scriptTag);
    };
  }, []);

  function handleCredentialResponse(response) {
    if (response.credential) {
      var data = { groups: "2", auth_token: response.credential };
      console.log("response.credential");
      console.log(response.credential);
      console.log("data", data);
      fetch(`${process.env.REACT_APP_API_URL}/api/google/`, {
        method: 'post',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
        },
      })
        .then((res) => res.json())
        .then((res) => {
          console.log("hwweeeeeeeeeeeeeeeee");
          let email = res['email'];
          console.log("mail", email);
          let token = res['tokens'];
          let access_token = token.access;
          console.log("toke", access_token);
          let user_id = res["user_id"];
          let username = res["username"];
          let is_verified_mobile = res["is_verified_mobile"];
          let is_verified = res["is_verified"];
          let is_verified_tc = res["is_verified_tc"];

          localStorage.setItem("userId", user_id);
          localStorage.setItem("user", username);
          localStorage.setItem("verified", is_verified);
          localStorage.setItem("verified_tc", is_verified_tc);

          localStorage.setItem("email", email);
          localStorage.setItem("token", access_token);

          console.log("email", localStorage.getItem("email"));
          console.log("token", localStorage.getItem("token"));

          let tc_status = localStorage.getItem("verified_tc");
          let mobile_status = localStorage.getItem("mobile");
          if (JSON.parse(tc_status) === false) {
            window.location.href = "/app/trainerdashboard";
          } else if (JSON.parse(mobile_status) === false) {
            window.location.href = "/app/trainerdashboard";
          } else {
            window.location.href = "/app/trainerdashboard";
          }
        });

    }
  }

  return (
    <>
      <DefaultNavbar
        routes={routes}
        sticky
      />
      <MKBox
        position="absolute"
        top={0}
        left={0}
        zIndex={1}
        width="100%"
        minHeight="100vh"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      <MKBox px={1} width="100%" height="100vh" mx="auto" position="relative" zIndex={2}>
        <Grid container spacing={1} justifyContent="center" alignItems="center" height="100%">
          <Grid item xs={11} sm={9} md={5} lg={4} xl={3.8}>
            <Card>
              <MKBox
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                mx={2}
                mt={-3}
                p={2}
                mb={1}
                textAlign="center"
              >
                <MKTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                  Great news!
                </MKTypography>
              </MKBox>
              <MKBox pt={4} pb={3} px={3}>
                <MKBox component="form" role="form">
                  <MKBox mb={2}>
                    <MKTypography variant="h6" fontWeight="medium" mt={1} style={{ whiteSpace: 'nowrap' }}>
                      Your Email-ID has been successfully verified !
                    </MKTypography>
                    <MKTypography variant="h6" fontWeight="medium" mt={2} style={{ whiteSpace: 'nowrap' }}>
                      Click the 'Sign In' button to continue as Training Partner.
                    </MKTypography>
                  </MKBox>
                  <MKBox mt={4} mb={1}>
                    <MKButton variant="gradient" color="info" type="submit" onClick={handleSubmitClick} fullWidth>
                      sign in
                    </MKButton>
                  </MKBox>
                </MKBox>
              </MKBox>
            </Card>
          </Grid>
        </Grid>
      </MKBox>
      <MKBox width="100%" position="absolute" zIndex={2} bottom="1.625rem">
        <SimpleFooter light />
      </MKBox>
    </>
  );
}

export default SignInBasic;
